import styled from 'styled-components';
import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import { Colors } from '~/config/Colors';


export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .row {
    margin-bottom: 0.5em;
  }

  .row-left {
    margin-bottom: 0.5em;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .no-margin {
    margin: 0 !important;
  }

  .header {
    padding: 0 0.6em;
    margin-bottom: 1em;

    .h-descricao {
      font-size: 0.7125em;
      line-height: 0.8em;
      color: ${Colors.Color7};
    }
  }

  .title_p {
    text-align: left;
    max-width: 100%;
    font-weight: 500;
    font-size: 0.75em;
    line-height: 1.8em;
    margin-bottom: 0.5em;
    color: ${Colors.Color7};
    ${props => props.row && `width: 6em; margin-bottom: 0em;`}
  }

  .row {

    .list-atv {
      margin-top: 1em !important;
    }

    .lateral {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      
      p {
        margin-left: 0.5em;
      }
    }

    .no-padding {
      padding: 0 !important;
    }

    .item {

      h6 {
        text-align: left;
        max-width: 100%;
        font-weight: 600;
        font-size: 0.8em;
        line-height: 1.8em;
        margin-bottom: 0em;
        color: ${Colors.Color4};
      }

      h3 {
        text-align: left;
        max-width: 100%;
        font-weight: 600;
        font-size: 1em;
        line-height: 1.8em;
        margin-bottom: 0.5em;
        color: ${Colors.Color7};
      }

      h5 {
        text-align: left;
        max-width: 100%;
        font-weight: 500;
        font-size: 0.85em;
        line-height: 1.8em;
        margin-bottom: 0.5em;
        color: ${Colors.Color7};
      }

      p {
        text-align: left;
        max-width: 100%;
        font-weight: 500;
        font-size: 0.85em;
        line-height: 1.8em;
        margin-bottom: 0.5em;
        color: ${Colors.color25};
      }
    }
  }

  .footer {
    position: fixed;
    bottom: 1rem;
    left: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 50%;

    .item-footer {
      margin-right: 1rem !important;
    }

    .btn-imp {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      background: ${Colors.Color4} !important;
      padding: 0.8rem 1rem;
      border-radius: 0.5rem;
      cursor: pointer;
      width: 10rem;

      p {
        font-size: 0.75rem;
        line-height: 0.8rem;
        color: ${Colors.Color1};
        font-weight: 600;
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    box-shadow: 0px 0px 19px 0px rgb(4 4 4 / 25%) !important;
    margin-bottom: 1.5em;
    border-radius: 0.4em;
    padding: 0em 1em 0em 1em !important;

    .content-top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .card-cod {
        background: ${Colors.Color2};
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 31%;
        margin-top: 0.75em;
        margin-bottom: 1.25em;

        .cod {
          font-size: 0.75em;
          font-weight: 500;
          color: ${Colors.Color4};
        }
      }
    }
  }

`;

export const ThisCardAtividade = styled.div`
  margin-bottom: 1.3em;
  padding: 0.8em;
  border-radius: 1em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  min-height: 5.2em;
  position: relative;
  overflow: hidden;
  background: ${Colors.Color1};

  ${props => {
    if (props?.ativo) {
      return `border: 0.1em solid ${Colors.Color8};`;
    }
  }}

  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: calc(100% - 10em);

    .content-top {
      display: flex;
      flex-direction: column;

      .card-top {
        line-height: 0.9em;

        .titulo {
          font-size: 0.8em;
          font-weight: bold;
          color: ${Colors.Color14};
        }

        .analista {
          white-space: pre;
          white-space: pre-line;
          white-space: pre-wrap;
          font-size: 0.7em;
          font-weight: 600;
          color: ${Colors.Color14};
        }
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .data {
        font-size: 0.65em;
        font-weight: 600;
        color: ${Colors.Color14};
      }

      .projeto {
        font-size: 0.65em;
        font-weight: 600;
        color: ${Colors.Color14};
      }

      .cliente {
        font-size: 0.65em;
        font-weight: 600;
        color: ${Colors.Color14};
      }
    }
  }

  .content-os {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 8em;

    p {
      margin-bottom: 0em !important;
    }

    .horario {
      display: flex;
      margin-bottom: 1em;

      .item-hora {
        display: flex;

        .card-numero {
          background: ${Colors.Color4};
          border-radius: 0.4em;
          display: flex;
          flex-direction: row;
          width: 1.4em;
          height: 1.4em;
          justify-content: center;
          align-items: center;
          margin-left: 0.45em;

          .numero {
            font-size: 0.7em;
            font-weight: 600;
            color: white;
          }
        }

        .card-hora {
          background: ${Colors.Color8};
          border-radius: 0.4em;
          padding: 0.2em 0.6em;
          display: flex;
          flex-direction: row;
          height: 1.4em;
          margin-left: 0.45em;
          justify-content: center;
          align-items: center;

          .hora {
            font-size: 0.7em;
            font-weight: 600;
            color: ${Colors.Color4};
            width: 100%;
          }
        }
      }
    }

    .totalizadores {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .desconto {
        font-size: 0.8em;
        font-weight: 600;
        color: ${Colors.Color14};
      }

      .translado {
        font-size: 0.8em;
        font-weight: 600;
        margin-left: 1em;
        color: ${Colors.Color14};
      }

      .card-total {
        background: ${Colors.Color8};
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        height: 1.4em;
        margin-left: 1em;
        justify-content: center;
        align-items: center;

        .total {
          font-size: 0.75em;
          font-weight: bold;
          color: ${Colors.Color4};
          width: 100%;
        }
      }
    }
  }
`;
